import React from "react";
import "./index.css";
import cn from "classnames";
import Textarea from "../../../layout/Textarea/Textarea";
import ContentEditable from "../../../layout/ContentEditable/ContentEditable";
import ImageUpload from "../../../layout/ImageUpload/index";
import {newsletterLayoutTypes, logoHyperskill} from "../../../data/constants";
import {withDeployVersion} from "../../../libs/deployVersion";
import {checkIfIDE} from "../../../data/products/index";
import Icon from "../../../layout/Icon";
import BgTransformer from "../../../layout/BgTransformer";
import {useSetting} from "../../../contexts/setting";
import {useEdits} from "../../../contexts/edits";
import {useBgUrl} from "hooks/useBgUrl";
import {useLogoUrl} from "../../../hooks/useLogoUrl";
import {HIDING_NAME_SET} from "data/products/index";
import {resolveVoucherDataRow} from "../../../libs/voucherData";

const Voucher = ({id, zoom}) => {
  const {product, layoutOption, iconOption, type} = useSetting();
  const {url: bgUrl} = useBgUrl();
  const {titles, subtitles, dates, badges, links, dataRows, productNames} = useEdits();
  const logoURL = useLogoUrl(id);

  const {dataRowIndex = 0} = useEdits();
  const firstRow =
    Array.isArray(dataRows) && dataRows.length > 0
      ? dataRows[Math.min(dataRowIndex, dataRows.length - 1)]
      : null;
  const {title, subtitle, badge, date, link} = resolveVoucherDataRow(firstRow, {
    title: titles[id] || titles.main,
    subtitle: subtitles[id] || subtitles.main,
    badge: badges[id] || badges.main,
    date: dates[id] || dates.main,
    link: links[id] || links.main,
  });
  const productName = productNames[id] || productNames.main || product.shortLabel || product.label;
  const isNewsletter = newsletterLayoutTypes.includes(type.value);
  const newsletterClass = isNewsletter ? "newsletter" : "";
  const templateClass = cn("template", `layout-${layoutOption}`, newsletterClass);
  const logoClass = cn("logo", {ide: checkIfIDE(product.value, type.value)});
  return (
    <>
      <div id={id} className={templateClass} style={{"--zoom-level": zoom}}>
        <div>
          <BgTransformer src={bgUrl} id={id} />

          <div className="content">
            <header className="template-header">
              <div className={logoClass}>
                <img src={logoURL} alt="background" />
              </div>
              {HIDING_NAME_SET.has(product.value) ? (
                ""
              ) : (
                <div className="product-name">
                  <ContentEditable id={id} text={productName} />
                </div>
              )}
              {product.value === "EDU" && <img src={withDeployVersion(logoHyperskill)} alt="background" />}
            </header>

            <div className="title-wrap">
              <h1 className="title">
                <Textarea id={id} text={title} />
              </h1>
              <h2 className="subtitle">
                <Textarea id={id} text={subtitle} />
              </h2>
            </div>
            <div className="badge">
              <Textarea id={id} text={badge} inline={true} />
            </div>

            <footer>
              <div className="date">
                <Textarea id={id} text={date} inline={true} />
              </div>
              <div className="link">
                <Textarea id={id} text={link} inline={true} />
              </div>
            </footer>
          </div>
        </div>
      </div>
    </>
  );
};

export default Voucher;
